import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "../container/Dashboard/Dashboard";
import Header from "../container/Header/header";
import Packing from "../container/Packing/Packing";
import ExtruderStatus from "../container/ExtruderStatus/ExtruderStatus";
import PackingHistory from "../container/Packing/PackingHistory";
import DispatchSummary from "../container/DispatchSummary/DispatchSummary";
import DispatchPrintHistory from "../container/DispatchSummary/DispatchPrintHistory";
import DispatchPrintPreview from "../container/DispatchSummary/DispatchPrintPreview";
import ProductionPlanning from "../container/ProductionPlanning/ProductionPlanning";
import ProductionAnalytics from "../container/ProductionAnalytics/ProductionAnalytics";
import SubProduction from "../container/ProductionAnalytics/SubProduction";
import UploadCSV from "../container/UploadCSV/UploadCSV";
import PrinterHealth from "../container/PrinterHealth/PrinterHealth"
import FootFallReport from "../container/FootFallReport/FootFallReport";

const AuthenticationRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/packing" element={<Packing />} />
                <Route path="/extruderStatus" element={<ExtruderStatus />} />
                <Route path="/packing-history" element={<PackingHistory />} />
                <Route path="/dispatch-summary" element={<DispatchSummary />} />
                <Route path="/dispatch-print-history" element={<DispatchPrintHistory />} />
                <Route path="/dispatch-print-preview" element={<DispatchPrintPreview />} />
                <Route path="/production-planning" element={<ProductionPlanning />} />
                <Route path="/production-analytics" element={<ProductionAnalytics />} />
                <Route path="/production-analytics/production" element={<SubProduction />} />
                <Route path="/upload-csv" element={<UploadCSV />} />
                <Route path="/printer-health" element={<PrinterHealth />} />
                <Route path="/footfall-report" element={<FootFallReport />} />
            </Routes>
        </>
    )
}

export default AuthenticationRoutes;